import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { Button, Modal } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';

import './ScopeModal.styles.scss';

type ScopeModalProps = {
  className?: string;
  onChoose: (applyOnExistingFiles: boolean) => void;
};

const ScopeModal: React.ForwardRefRenderFunction<ModalRef, ScopeModalProps> = (
  props,
  ref,
) => {
  const { className, onChoose } = props;

  const classes = classNames('scope-modal', className);

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const { t } = useTranslation();

  return (
    <Modal ref={modalRef} className={classes} title={t('securityScope')}>
      <p>{t('securityScopeQuestion')}</p>

      <div className="actions">
        <Button variant="outline" onClick={() => onChoose(true)}>
          {t('applyToAllFiles')}
        </Button>
        <Button onClick={() => onChoose(false)}>
          {t('applyToFutureFilesOnly')}
        </Button>
      </div>
    </Modal>
  );
};

export default forwardRef(ScopeModal);
